module.exports = __webpack_public_path__ + "static/alum3-78821915e56f944ca520ec3766b066d4.png";